import { PaginationMetadata } from '@services/providers/cosem.types';
import { createColumnHelper } from '@tanstack/react-table';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { NewsTable } from '@services/product/news/news.types';
import { useDeleteNewsMutation } from '@services/product/news/news.endpoints';

export const useNewsListPageVM = () => {
    const [totalNews, setTotalNews] = useState<number>(0);
    const columnHelper = createColumnHelper<NewsTable>();
    const [needReload, setNeedReload] = useState<boolean>();
    const navigate = useNavigate();
    const MySwal = withReactContent(Swal);

    const [deleteNews, { isSuccess: isDeleteNewsSuccess, isLoading: isDeleteNewsLoading }] = useDeleteNewsMutation();

    useEffect(() => {
        if (isDeleteNewsSuccess) {
            setNeedReload((prev) => !prev);
        }
    }, [isDeleteNewsSuccess]);

    const handleMetadata = (metadata: PaginationMetadata) => {
        if (metadata && metadata.total !== undefined) {
            setTotalNews(metadata.total);
        }
    };

    const handleDeleteNews = (id: number) => {
        MySwal.fire({
            title: 'Êtes-vous sûr de vouloir supprimer cette actualité ?',
            icon: 'warning',
            showCancelButton: true,
            iconColor: '#5D4B99',
            confirmButtonColor: '#5D4B99',
            confirmButtonText: 'Supprimer',
            cancelButtonText: 'Annuler'
        }).then((result) => {
            if (result.isConfirmed) {
                console.log(result);
                deleteNews({ id });
            }
        });
    };

    const handleDeleteMultipleNews = (lines: NewsTable[]) => {
        MySwal.fire({
            title: 'Êtes-vous sûr de vouloir supprimer ces actualités ?',
            icon: 'warning',
            showCancelButton: true,
            iconColor: '#5D4B99',
            confirmButtonColor: '#5D4B99',
            confirmButtonText: 'Supprimer',
            cancelButtonText: 'Annuler'
        }).then((result) => {
            if (result.isConfirmed) {
                lines.forEach((line) => {
                    deleteNews({ id: line.id });
                });
            }
        });
    };

    const handleDuplicateNews = (id: number) => {
        navigate(`/products-management/news/${id}/duplicate`);
    };

    return {
        totalNews,
        setTotalNews,
        columnHelper,
        needReload,
        navigate,
        handleMetadata,
        handleDeleteNews,
        handleDuplicateNews,
        handleDeleteMultipleNews,
        isLoading: isDeleteNewsLoading
    };
};
